import { render } from "./CrmDealKanbanBoardDealsTicketCard.vue?vue&type=template&id=8b590f8e&scoped=true"
import script from "./CrmDealKanbanBoardDealsTicketCard.vue?vue&type=script&lang=js"
export * from "./CrmDealKanbanBoardDealsTicketCard.vue?vue&type=script&lang=js"

import "./CrmDealKanbanBoardDealsTicketCard.vue?vue&type=style&index=0&id=8b590f8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b590f8e"]])

export default __exports__